const stateMapper = array => array.map(
  ({ key, name }) => ({
    value: key,
    label: name,
  }),
);

const mappers = {
  stateMapper,
};

export default mappers;
